<script setup>
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";
import { onMounted, ref, inject, computed, defineAsyncComponent } from "vue";
import { router, usePage, Link } from "@inertiajs/vue3";
import Logo from "@/Components/AdminLayout/logo/HomeLogo.vue";

const ReCaptcha2 = defineAsyncComponent(() =>
  import("@/Components/Input/ReCaptcha2.vue")
);
import { useToast } from "vue-toastification";

const page = usePage();
import { useDisplay } from "vuetify";
import { HandleErrorAxios } from "@/Composable/HandleError";

const __t = inject("__t");

const $toast = useToast();

const { mdAndDown, lgAndUp, smAndDown } = useDisplay();

const isPageLoaded = ref(false);
const isSending = ref(false);

onMounted(() => {
  if (!import.meta.env.SSR) {
    setTimeout(() => {
      if (document.readyState === "complete") {
        isPageLoaded.value = true;
      }
    }, 500);
  }
});

const name = ref("");
const phone = ref("");
const email = ref("");
const message = ref("");
const grecaptcharesponse = ref();
const title = ref();
const verifyMethod = (response) => {
  grecaptcharesponse.value = response;
};
const errors = ref({});
const submit = async () => {
  title.value = document.title;
  isSending.value = true;
  axios
    .post(route("api.callUsPost"), {
      name: name.value,
      email: email.value,
      phone: phone.value,
      title: title.value,
      msg: message.value,
      "g-recaptcha-response": grecaptcharesponse.value,
    })
    .then((res) => {
      isSending.value = false;

      $toast.success(__t("sent"));
      name.value = "";
      email.value = "";
      phone.value = "";
      message.value = "";
      grecaptcharesponse.value = "";
    })
    .catch((error) => {
      isSending.value = false;

      HandleErrorAxios(error, errors);
    });
};

const isSendDisabled = () => {
  if (phone.value === undefined || phone.value?.length === 0) {
    return true;
  }
  if (name.value === undefined || name.value?.length === 0) {
    return true;
  }
  if (email.value === undefined || email.value?.length === 0) {
    return true;
  }
  if (message.value === undefined || message.value?.length === 0) {
    return true;
  }
  return false;
};

const locale = computed(() => {
  return page.props.locale;
});
</script>
<template>
  <div id="contact" class="pt-12 pb-12 bg-top bg-no-repeat bg-cover border min-h-96 dark:bg-black"
>
  <v-container data-aos="fade-up">
  
    <!-- data-aos="fade-up" -->
    <div class="py-12 px-7 px-md-12 ">
      <v-row class="items-center justify-center" no-gutters>
        <v-col cols="12" md="6" class="flex items-center mt-20 md:mt-0">
          <div class="space-y-5">
            <Logo class="h-18" />
            <div v-if="$page.props.setting.address">

            {{ $page.props.setting.address }}
            </div>
            <h1 class="text-4xl font-bold text-primarydark">
              {{ __t("letUsContactYou") }}
            </h1>

          
            <h2 class="text-sm font-bold">
              {{ __t("contactUs") }}

            </h2>
            <div class="">
              <div class="flex justify-between">
                <ul class="flex flex-col gap-x-7">
                  <li class="flex flex-row items-center gap-3 text-lg">
                    <a class="flex items-center justify-center gap-2"
                      :href="`mailto:${$page.props.setting.email_address}`" target="_blank">
                      <div class="flex items-center justify-center w-10 h-10 my-3 rounded-full border-primary">
                        <v-icon icon="mdi-email" size="25" class="text-primary" color="primary" />
                      </div>
                      <p>{{ $page.props.setting.email_address }}</p>
                    </a>
                  </li>
                  <li class="flex flex-row items-center gap-3 text-lg">
                    <a class="flex items-center justify-center gap-2"
                      :href="`tel:${$page.props.setting.phone}`" target="_blank">
                      <div class="flex items-center justify-center w-10 h-10 my-3 rounded-full borde r-2 border-primary">
                        <v-icon icon="mdi-phone" size="25" class="text-primary" color="primary" />
                      </div>
                      <p>{{ $page.props.setting.phone }}</p>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="mt-5">
                <ul class="flex items-start justify-start w-full gap-1 mt-2 mb-5 mb-md-3">
                  <li v-if="$page.props.setting.instagram">
                    <a :href="$page.props.setting.instagram" target="_blank">
                      <v-btn aria-label="instagram" icon variant="text">
                        <v-icon icon="mdi-instagram" size="30" />
                      </v-btn>
                    </a>
                  </li>
                  <li v-if="$page.props.setting.facebook">
                    <a :href="$page.props.setting.facebook" target="_blank">
                      <v-btn aria-label="facebook" icon variant="text">
                        <v-icon icon="mdi-facebook" size="30" />
                      </v-btn>
                    </a>
                  </li>
                  <li v-if="$page.props.setting.twitter">
                    <a :href="$page.props.setting.twitter" target="_blank">
                      <v-btn aria-label="twitter" icon variant="text">
                        <v-icon icon="mdi-twitter" size="30" />
                      </v-btn>
                    </a>
                  </li>
                  <li v-if="$page.props.setting.youtube">
                    <a :href="$page.props.setting.youtube" target="_blank">
                      <v-btn aria-label="youtube" icon variant="text">
                        <v-icon icon="mdi-youtube" size="30" />
                      </v-btn>
                    </a>
                  </li>
                  <li v-if="$page.props.setting.whatsapp">
                    <a :href="$page.props.setting.whatsapp" target="_blank">
                      <v-btn aria-label="whatsapp" icon variant="text">
                        <v-icon icon="mdi-whatsapp" size="30" />
                      </v-btn>
                    </a>
                  </li>
                  <li v-if="$page.props.setting.linkedin">
                    <a :href="$page.props.setting.linkedin" target="_blank">
                      <v-btn aria-label="linkedin" icon variant="text">
                        <v-icon icon="mdi-linkedin" size="30" />
                      </v-btn>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div>
            <form class="space-y-5" @submit.prevent="submit">
              <v-text-field class='mb-5 rounded' hide-details v-model="name" :error="!!errors?.name" :error-messages="errors?.name" type="text"
                rounded="lg" variant="outlined" color="primarydark" bg-color="transparent" :placeholder="__t('name')"
                :dir="locale === 'ar' ? 'rtl' : 'ltr'">
                <template #append-inner>
                  <v-icon icon="mdi-form-textbox" size="30" />

                  <!-- <Icon name="ph:user" size="30" color="white" /> -->
                </template>
              </v-text-field>
              <div>
                <vue-tel-input  hide-details dir="ltr" mode="international" v-model="phone" :inputOptions="{
                  placeholder: __t('phone'),
                  autocomplete: 'on',
                  required: true,
                }" :dropdownOptions="{
                    showDialCodeInList: true,
                    showDialCodeInSelection: true,
                    showFlags: true,
                    showSearchBox: true,
                  }" :preferredCountries="['AE', 'TR', 'IQ', 'SA', 'LY', 'SY']" :class="`rounded-lg h-[50px] bg-white  z-50 ${errors?.phone ? 'error' : ''
                    }`">
                </vue-tel-input>
                <p v-if="errors?.phone" class="m-0 mt-2 text-xs ms-5 text-red">
                  {{ __t("phoneValidation") }}
                </p>
              </div>
              <v-text-field class='mb-5 rounded' hide-details :error="!!errors?.email" :error-messages="errors?.email" type="text" rounded="lg"
                variant="outlined" color="primarydark" bg-color="transparent" v-model="email"
                :placeholder="__t('email')" :dir="locale === 'ar' ? 'rtl' : 'ltr'">
                <template #append-inner>
                  <v-icon icon="mdi-email-open-outline" size="30" />

                  <!-- <Icon name="ph:envelope" size="30" color="white" /> -->
                </template>
              </v-text-field>
              <v-textarea class='mb-5 rounded ' hide-details v-model="message" type="textarea" :error="!!errors?.message" :error-messages="errors?.message"
                rounded="lg" variant="outlined" bg-color="transparent" color="primarydark" :placeholder="__t('message')"
                :dir="locale === 'ar' ? 'rtl' : 'ltr'">
                <template #append-inner>
                  <v-icon icon="mdi-chat-outline" size="30" />

                  <!-- <Icon name="ph:chat" size="30" color="white" /> -->
                </template>
              </v-textarea>
              <v-no-ssr>
                <ReCaptcha2 @verified="verifyMethod" :reset="!!errors['g-recaptcha-response']">
                </ReCaptcha2>
              </v-no-ssr>
              <v-btn @click.prevent="submit()" :disabled="isSendDisabled()" class="w-full" rounded="lg" color="primary"
                :loading="isSending">
                <div class="font-bold text-[15px]">
                  {{ __t("send") }}
                </div>
              </v-btn>
            </form>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</div>
</template>
<style scoped>
.vue-tel-input {
  border: 1px solid rgb(0 0 0 / 40%);
}

:deep(.error) {
  border: 1px solid red !important;
}

.vue-tel-input:hover {
  border: 1px solid rgba(256, 256, 256, 1);
  box-shadow: none;
}

.vue-tel-input:focus-within {
  border: 2px solid rgba(var(--v-theme-primarydark), 1);
  box-shadow: none;
  transition: all ease-in 400ms;
}

:deep(.vti__dropdown-list) {
  background-color: black !important;
  color: rgb(4, 4, 4) !important;
  border-radius: 8px;
}

:deep(.highlighted) {
  background-color: rgba(var(--v-theme-primarydark), 1) !important;
}

:deep(.vti__dropdown):hover {
  background-color: rgba(256, 256, 256, 0.1) !important;
  border-radius: 8px;
}

:deep(.open) {
  background-color: rgba(256, 256, 256, 0.1) !important;
  border-radius: 8px;
}
</style>
